import { createSelector } from 'reselect';
import {
  getMyDrawEntity,
  getMyTeamEntity,
  getOpponentDrawEntity,
} from '../pairingSelector';
import { DrawRoundActionView, DrawRoundView } from './view/DrawRoundView';

export const drawRoundPresenter = createSelector(
  [getMyTeamEntity, getMyDrawEntity, getOpponentDrawEntity],
  (myTeam, myDraw, opponentDraw): DrawRoundView => {
    const displayDraw =
      (myDraw?.myTeamArmyConfirmed ?? false) &&
      (opponentDraw?.myTeamArmyConfirmed ?? false);

    const displayResponse =
      displayDraw &&
      (myDraw?.propositionTeamArmyConfirmed ?? false) &&
      (opponentDraw?.propositionTeamArmyConfirmed ?? false);

    const displayMySelectionText =
      displayResponse && !(myDraw?.selectedTeamArmyConfirmed ?? false);
    const displayMyResponseText =
      !displayMySelectionText &&
      !opponentDraw?.propositionTeamArmyConfirmed &&
      displayDraw;
    const displayMyDrawText =
      !displayMyResponseText && !(myDraw?.myTeamArmyConfirmed ?? false);

    return new DrawRoundView({
      displayDraw: displayDraw,
      displayMyDraw: (displayDraw || myDraw?.myTeamArmyId != null) ?? false,
      displayResponse: displayResponse,
      displayMyResponse:
        displayDraw &&
        (opponentDraw?.propositionTeamArmyOneId != null ||
          opponentDraw?.propositionTeamArmyTwoId != null ||
          displayResponse),
      myTeamId: myTeam!.id,
      myDraw: myDraw,
      opponentDraw: opponentDraw,
      action: new DrawRoundActionView({
        myArmy: displayMyDrawText,
        myResponse: displayMyResponseText,
        mySelection: displayMySelectionText,
      }),
    });
  },
);
